// Datos de afiliados Physiology — generado desde Excel + Nominatim, con fixes manuales
// Coordenadas vía OpenStreetMap (gratis, sin API key, no se llama en runtime)
export const storeLocations = [
  {
    "id": "1",
    "name": "Melody Denisse",
    "business": "MELODY BEAUTY LAB",
    "address": "CALLE F 675 EJIDO RUIZ CORTINES CP 22810",
    "city": "Ensenada",
    "state": "Baja California",
    "phone": "6462566320",
    "whatsapp": "6462566320",
    "email": "ascenciomelody@gmail.com",
    "instagram": "",
    "facebook": "",
    "type": "distributor",
    "lat": 31.8658887,
    "lng": -116.602983
  },
  {
    "id": "2",
    "name": "Brenda Lisete Nuño (clinica Nova Imagen)",
    "business": "CLINICA NOVA IMAGEN",
    "address": "PASEO DE LAS OLAS 708 FRACCIONAMIENTO COSTA DORADA C.P 22845 ENSENADA BAJA CALIFORNIA ENTRE PASEO LAS ROCAS Y GRANADA",
    "city": "Ensenada",
    "state": "Baja California",
    "phone": "6461762370",
    "whatsapp": "6461939298",
    "email": "clinicanovaimagen@hotmail.com",
    "instagram": "https://instagram.com/clinicanovaimagen",
    "facebook": "https://facebook.com/ClinicaNovaImagen",
    "type": "distributor",
    "lat": 31.8658887,
    "lng": -116.602983
  },
  {
    "id": "3",
    "name": "Itzel Adriana Garcia Soto",
    "business": "ITZEL AESTHETIC NURSE",
    "address": "GONZALEZ ORTEGA #1150 COL, CENTRO CP. 22000 DIRECCIÓN PERSONAL: CALLE FRANCISCO VILLA #2610 COL. CHILPANCINGO, TIJUANA, BAJA CALIFORNIA CP. 22440",
    "city": "Tijuana",
    "state": "Baja California",
    "phone": "6643627072",
    "whatsapp": "6643627072",
    "email": "itzelagsoto@gmail.com",
    "instagram": "https://instagram.com/itzel.aestheticnurse",
    "facebook": "",
    "type": "distributor",
    "lat": 32.5317397,
    "lng": -117.019529
  },
  {
    "id": "4",
    "name": "pr Medical ( Paloma)",
    "business": "PR MEDICA INC",
    "address": "PLAZA PASCO ESPERANZA L3 COL. CERRO COLORADO CP 23406",
    "city": "San José del Cabo",
    "state": "Baja California Sur",
    "phone": "6246888497",
    "whatsapp": "",
    "email": "info@prmedica-inc.com",
    "instagram": "",
    "facebook": "https://facebook.com/PRMEDICAINC",
    "type": "distributor",
    "lat": 23.0598364,
    "lng": -109.7025148
  },
  {
    "id": "5",
    "name": "Dra. Jacqueline Estefania Jimenez Castañeda",
    "business": "DRA. ESTEFANIA JIMENEZ",
    "address": "CALLE LIBERTAD ESQUINA DE LOS MARES, PLAZA SOLEI LOCAL 14 LIENZO CHARRO CP 23470",
    "city": "San José del Cabo",
    "state": "Baja California Sur",
    "phone": "6243550913",
    "whatsapp": "6243550913",
    "email": "estefania_jimast64@gmail.com",
    "instagram": "https://instagram.com/draestefaniajimenez",
    "facebook": "https://facebook.com/Dra.EstefaniaJim",
    "type": "distributor",
    "lat": 23.0598364,
    "lng": -109.7025148
  },
  {
    "id": "6",
    "name": "Adriana Galindo Garcia",
    "business": "",
    "address": "",
    "city": "",
    "state": "CDMX",
    "phone": "",
    "whatsapp": "",
    "email": "agalindo@me.com",
    "instagram": "",
    "facebook": "",
    "type": "distributor",
    "lat": 19.3207722,
    "lng": -99.1514678
  },
  {
    "id": "7",
    "name": "Rocio Isabel Dominguez Castillo",
    "business": "ALLURE BLISS",
    "address": "Acueducto #698, interior 304, Residencial Zacatenco, CDMX. C.P. 07340",
    "city": "Ciudad de México",
    "state": "CDMX",
    "phone": "5545884805",
    "whatsapp": "",
    "email": "romau7223@hotmail.com",
    "instagram": "https://www.instagram.com/allurebliss_skincare",
    "facebook": "",
    "type": "distributor",
    "lat": 19.4326296,
    "lng": -99.1331785
  },
  {
    "id": "8",
    "name": "Tania Salinas Carrillo",
    "business": "Bunoo by Tania Carrillo",
    "address": "Lázaro Cardenas 208 Col. Huayamilpas 04300 CDMX, Coyoacan",
    "city": "Ciudad de México",
    "state": "CDMX",
    "phone": "5585582369",
    "whatsapp": "5585582369",
    "email": "taniiasalinas@gmail.com",
    "instagram": "https://instagram.com/bunoo_bytaniacarrillo",
    "facebook": "",
    "type": "distributor",
    "lat": 19.3209881,
    "lng": -99.1511282
  },
  {
    "id": "9",
    "name": "Anahi Espinoza",
    "business": "Face The Beauty",
    "address": "CALLE COLIMA #220 INTERIOR 404 COLONIA ROMA NORTE LOCALIDAD CUAUHTEMOC CIUDAD DE MEXICO CP 06700",
    "city": "Ciudad de México",
    "state": "CDMX",
    "phone": "5548480488",
    "whatsapp": "5548480488",
    "email": "maartinamx@gmail.com",
    "instagram": "https://instagram.com/facethebeauty.mx",
    "facebook": "",
    "type": "distributor",
    "lat": 19.4326296,
    "lng": -99.1331785
  },
  {
    "id": "10",
    "name": "Maria Gabriela Moran",
    "business": "RITUAL SPA FACIAL",
    "address": "Avenida Juárez 120, Colonia Mayorazgos de los Gigantes, Ciudad López Mateos, Atizapan, Estado de México, CP 52957",
    "city": "Atizapán de Zaragoza",
    "state": "Estado de México",
    "phone": "5566177238",
    "whatsapp": "5566177238",
    "email": "ritual.skincare@gmail.com",
    "instagram": "https://instagram.com/ritual.spafacial",
    "facebook": "",
    "type": "distributor",
    "lat": 19.5877331,
    "lng": -99.0399118
  },
  {
    "id": "11",
    "name": "Ma. Teresa Covarubias Saucedo (nattural Esencial Spa)",
    "business": "NATURAL ESENCIAL SPA Cosmetología Integral",
    "address": "BOULEVARD MARIANO J. GARCÍA #895 INT B PLAZA MIA RESIDENCIAL CIBELES Cp. 36643 DIRECCIÓN PERSONAL: CIRCUITO REAL 236 FRACCIONAMIENTO QUINTA REAL IRAPUATO GUANAJUATO C.P. 36644",
    "city": "Irapuato",
    "state": "Guanajuato",
    "phone": "4626215258",
    "whatsapp": "4626215258",
    "email": "natturalesencial@gmail.com",
    "instagram": "https://instagram.com/natturalesencialspa",
    "facebook": "https://facebook.com/natturalesencialspa",
    "type": "distributor",
    "lat": 20.6758761,
    "lng": -101.3521052
  },
  {
    "id": "12",
    "name": "Michael Ruiz",
    "business": "MichaelSkin & spa",
    "address": "Lib. Luis Donaldo Colosio 550, Lázaro Cárdenas, 48330 Puerto Vallarta, Jal., México",
    "city": "Puerto Vallarta",
    "state": "Jalisco",
    "phone": "3223817609",
    "whatsapp": "",
    "email": "michaelmjrl12@gmail.com",
    "instagram": "",
    "facebook": "",
    "type": "distributor",
    "lat": 20.6407176,
    "lng": -105.220306
  },
  {
    "id": "13",
    "name": "",
    "business": "Aoura Studio Facial & Corporal",
    "address": "Lisboa 127 int 1, Col. La Vena, CP 48320",
    "city": "Puerto Vallarta",
    "state": "Jalisco",
    "phone": "3224454575",
    "whatsapp": "3222170928",
    "email": "aourastudiopv@gmail.com",
    "instagram": "https://instagram.com/aouraskinstudio",
    "facebook": "",
    "type": "distributor",
    "lat": 20.6407176,
    "lng": -105.220306
  },
  {
    "id": "14",
    "name": "Alondra Orozco",
    "business": "Skin Center Spa",
    "address": "Matamoros 30, Col. San José, CP 47190",
    "city": "San Ignacio Cerro Gordo",
    "state": "Jalisco",
    "phone": "3487161298",
    "whatsapp": "3487161298",
    "email": "natycueba@hotmail.com",
    "instagram": "",
    "facebook": "",
    "type": "distributor",
    "lat": 20.7686814,
    "lng": -102.5148145
  },
  {
    "id": "15",
    "name": "Nancy Vianey Arroyo",
    "business": "Relieve clínica spa",
    "address": "RIO CUPATITZIO PRIMER SECTOR FILEDAC CP 60956",
    "city": "Lázaro Cárdenas",
    "state": "Michoacán",
    "phone": "4431616562",
    "whatsapp": "",
    "email": "",
    "instagram": "",
    "facebook": "",
    "type": "distributor",
    "lat": 17.9594769,
    "lng": -102.198659
  },
  {
    "id": "16",
    "name": "Daniela Mejia Barradas",
    "business": "DM Cosmetology",
    "address": "Ramón Garcés #83, Col. Hacienda La Trinidad, CP 58195",
    "city": "Morelia",
    "state": "Michoacán",
    "phone": "4431725305",
    "whatsapp": "",
    "email": "distribuidoradm_16@hotmail.com",
    "instagram": "",
    "facebook": "",
    "type": "distributor",
    "lat": 19.7036,
    "lng": -101.1949
  },
  {
    "id": "17",
    "name": "Cynthia Gonzalez Cotero",
    "business": "Vitas Skin",
    "address": "CALLE MIGUEL NEGRETE # 57 COL. CUAUTLIXCO HUANACASTLE #8 FRACC. AMATES DE OAXTEPEC, YAUTEPEC MORELOS CP. 62738",
    "city": "Cuautla",
    "state": "Morelos",
    "phone": "7351369850",
    "whatsapp": "5635779941",
    "email": "cyngoncot@gmail.com",
    "instagram": "https://instagram.com/vitaskincuautla",
    "facebook": "https://facebook.com/vitasskincuautla",
    "type": "distributor",
    "lat": 18.8150158,
    "lng": -98.9736172
  },
  {
    "id": "18",
    "name": "Delicia Flores Romano",
    "business": "DELLY SPA",
    "address": "CALLE 5 #18 FRACCIONAMIENTO EXTENSION VISTA HERMOSA COLONIA VISTA HERMOSA CUERNAVACA MORELOS CP 62295",
    "city": "Cuernavaca",
    "state": "Morelos",
    "phone": "7772187844",
    "whatsapp": "7772187844",
    "email": "deli_romano@hotmail.com",
    "instagram": "https://instagram.com/deli.spa",
    "facebook": "",
    "type": "distributor",
    "lat": 18.9331321,
    "lng": -99.2599579
  },
  {
    "id": "19",
    "name": "Miriam Del Carmen Martinez Gonzalez",
    "business": "Bionut Center centro de Cosmetología y Belleza",
    "address": "Av. Plan de Ayala #1759 ,plaza cascada local A-21 cp 62420",
    "city": "Cuernavaca",
    "state": "Morelos",
    "phone": "7771490311",
    "whatsapp": "7771490311",
    "email": "bionut.mex@gmail.com",
    "instagram": "https://instagram.com/bionut.center",
    "facebook": "https://facebook.com/BionutCenter",
    "type": "distributor",
    "lat": 18.9331321,
    "lng": -99.2599579
  },
  {
    "id": "20",
    "name": "Islet Juarez Cruz ( Islet Skin & Spa )",
    "business": "ISLET SKIN Y SPA",
    "address": "GERARDO VARELA No. 204 LOMAS DEL CRESTON OAXACA DE JUAREZ C.P. 68024",
    "city": "Oaxaca",
    "state": "Oaxaca",
    "phone": "2223108542",
    "whatsapp": "",
    "email": "islettelsi@hotmail.com",
    "instagram": "https://instagram.com/isletskinyspa",
    "facebook": "",
    "type": "distributor",
    "lat": 17.0604663,
    "lng": -96.7253575
  },
  {
    "id": "21",
    "name": "Indra Esther Acevedo Garcia",
    "business": "INDRA COSMETICA",
    "address": "CALLE HUZARES No. 110 COLONIA CENTRO OAXACA OAXACA C.P. 68000",
    "city": "Oaxaca",
    "state": "Oaxaca",
    "phone": "9516245772",
    "whatsapp": "9516245772",
    "email": "es01indra@gmail.com",
    "instagram": "https://www.instagram.com/indraecosmetica",
    "facebook": "",
    "type": "distributor",
    "lat": 17.0604663,
    "lng": -96.7253575
  },
  {
    "id": "22",
    "name": "Leslie Alejandra Martinez",
    "business": "COSMETOLOGIA LEA",
    "address": "ISABELA CATOLICA 47c BARRIO DE SAN SEBASTIAN HEROICA CIUDAD DE TLAXIACO OAXACA CP 69890",
    "city": "Oaxaca",
    "state": "Oaxaca",
    "phone": "2216449869",
    "whatsapp": "",
    "email": "lesliegd@gmail.com",
    "instagram": "",
    "facebook": "",
    "type": "distributor",
    "lat": 17.0604663,
    "lng": -96.7253575
  },
  {
    "id": "23",
    "name": "Diana Monserrat Martinez Lopez",
    "business": "TESS BEAUTY & STUDIO",
    "address": "Francisco Márquez 108, CALZADA MADERO, Ex-Marquezado, 68030 Oaxaca de Juárez, Oax.",
    "city": "Oaxaca",
    "state": "Oaxaca",
    "phone": "9512162279",
    "whatsapp": "9512162279",
    "email": "healthyskintv@gmail.com",
    "instagram": "",
    "facebook": "https://www.facebook.com/tesssbeautystudio",
    "type": "distributor",
    "lat": 17.0604663,
    "lng": -96.7253575
  },
  {
    "id": "24",
    "name": "Emma Eddaly Cruz",
    "business": "EMMA COSMETOLOGIA",
    "address": "CALLE MIGUEL HIDALGO No. 7 OAXACA SAN SEBASTIAN TUTLA C.P. 71320",
    "city": "Oaxaca",
    "state": "Oaxaca",
    "phone": "9515709075",
    "whatsapp": "",
    "email": "emma.cosmetologia.mx@gmail.com",
    "instagram": "https://instagram.com/emma.cosmetologia.mx",
    "facebook": "https://facebook.com/emmacosmetologia",
    "type": "distributor",
    "lat": 17.0604663,
    "lng": -96.7253575
  },
  {
    "id": "25",
    "name": "Itzel Stephane Ojeda",
    "business": "Skinlove Off Clínica Cosmetólogica",
    "address": "Primera Priv. Nicolás Bravo 5-2do piso, Santa Cruz Xoxocotlán, 71230 Oaxaca de Juárez, Oax.",
    "city": "Oaxaca de Juearez",
    "state": "Oaxaca",
    "phone": "9516350917",
    "whatsapp": "9516350917",
    "email": "fannyojeda_skincare@hotmail.com",
    "instagram": "https://instagram.com/Skinlove_off",
    "facebook": "https://facebook.com/SkinloveOffCl",
    "type": "distributor",
    "lat": 17,
    "lng": -96.5
  },
  {
    "id": "26",
    "name": "Erika Michael Parra Dominguez",
    "business": "Nirvana Day Spa",
    "address": "Ponciano Medina número 170 cp 68300",
    "city": "San Juan Bautista Tuxtepec",
    "state": "Oaxaca",
    "phone": "2226720847",
    "whatsapp": "2226720847",
    "email": "nirvanadayspa@outlook.es",
    "instagram": "https://instagram.com/nvaspa",
    "facebook": "",
    "type": "distributor",
    "lat": 18.0874632,
    "lng": -96.1227767
  },
  {
    "id": "27",
    "name": "Maria Luisa Lecona Hernandez (centro de Estudios Cosmetologicos Lecona)",
    "business": "CENTRO DE ESTUDIOS COSMETOLOGICOS LECONA",
    "address": "CIRCUITO JUAN PABLO II No. 919-1 COLONIA PRADOS AGUA AZUL, PUEBLA, PUEBLA CP. 72430",
    "city": "Puebla",
    "state": "Puebla",
    "phone": "2227657237",
    "whatsapp": "2222386524",
    "email": "cosmetologia.lecona@gmail.com",
    "instagram": "",
    "facebook": "https://facebook.com/centrodeestudioscosmetologicoslecona",
    "type": "distributor",
    "lat": 19.0437196,
    "lng": -98.1981486
  },
  {
    "id": "28",
    "name": "Nancy Flores",
    "business": "NANCY FLORES COSMETOLOGIA",
    "address": "Calle 5 oriente #10 edificio Dulce María. Segundo piso Local 10.",
    "city": "Tecamachalco",
    "state": "Puebla",
    "phone": "2491230243",
    "whatsapp": "",
    "email": "afnancyle@gmail.com",
    "instagram": "https://instagram.com/nancy_cosmetolog_af",
    "facebook": "",
    "type": "distributor",
    "lat": 18.8640574,
    "lng": -97.7282334
  },
  {
    "id": "29",
    "name": "Irisbeth Perez Feregrino",
    "business": "TOPICO ESTETICA-INTEGRAL",
    "address": "C. INVIERNO No. 175, COLONIA ESPAÑA SANTIAGO DE QUERETARO QUERETARO QUERETARO C.P. 76158",
    "city": "Querétaro",
    "state": "Querétaro",
    "phone": "4426379180",
    "whatsapp": "4426379180",
    "email": "topico.estetica.integral@gmail.com",
    "instagram": "https://instagram.com/hola_topico",
    "facebook": "https://facebook.com/Topico-EsteticaIntegral",
    "type": "distributor",
    "lat": 20.5922997,
    "lng": -100.3917424
  },
  {
    "id": "30",
    "name": "Dra. Rocio Janeth Albor Padilla",
    "business": "DOCTORA ROCIO ALBOR",
    "address": "AV. PALMIRA 655 INT 4G PRIVADAS DEL PEDREGAL SAN LUIS POTOSI",
    "city": "San Luis Potosí",
    "state": "San Luis Potosí",
    "phone": "4441833839",
    "whatsapp": "",
    "email": "dra.rocioalbor@gmail.com",
    "instagram": "",
    "facebook": "",
    "type": "distributor",
    "lat": 22.1516472,
    "lng": -100.9763993
  },
  {
    "id": "31",
    "name": "Jasmin Joselin Campos Campos",
    "business": "Skincare Cabin Yascampos",
    "address": "CALLE DIF No. 1090 COLONIA STASE III CULIACÁN ROSALES SINALOA C.P. 80020",
    "city": "Culiacan",
    "state": "Sinaloa",
    "phone": "6673063766",
    "whatsapp": "6673063766",
    "email": "yascamposkincarecabin@gmail.com",
    "instagram": "https://www.instagram.com/yascampos.skincarecabin",
    "facebook": "",
    "type": "distributor",
    "lat": 24.7978965,
    "lng": -107.393395
  },
  {
    "id": "32",
    "name": "Yajaira Ivonnet Manjarrez",
    "business": "nombre del negocio 1: yimanjarrez",
    "address": ": República de Brasil #1816-A Col. Infonavit Humaya, Culiacán, Sinaloa #80020",
    "city": "Culiacan",
    "state": "Sinaloa",
    "phone": "6671577540",
    "whatsapp": "",
    "email": "ivonet.manjarez.roman@gmail.com",
    "instagram": "",
    "facebook": "",
    "type": "distributor",
    "lat": 24.7978965,
    "lng": -107.393395
  },
  {
    "id": "33",
    "name": "",
    "business": "Nombre del negocio 2: MM Concept Store",
    "address": "Calle presa vasequillos y presa san lorenzo #1010-3, Culiacán, Sinaloa #80060",
    "city": "Culiacan",
    "state": "Sinaloa",
    "phone": "6674633752",
    "whatsapp": "6674633752",
    "email": "ivonet.manjarez.roman@gmail.com",
    "instagram": "",
    "facebook": "",
    "type": "distributor",
    "lat": 24.7978965,
    "lng": -107.393395
  },
  {
    "id": "34",
    "name": "Benita Claribel Sanchez Valenzuela",
    "business": "Jabe Beauty Spa",
    "address": "HERIBERTO VALDEZ 926 PLAZA LUCERO LOCAL 3 ENTRE ROSALES Y RIO TAMAZULA CP 81240",
    "city": "Los Mochis",
    "state": "Sinaloa",
    "phone": "6681293610",
    "whatsapp": "",
    "email": "jabe.beauty.spa@gmail.com",
    "instagram": "https://instagram.com/jabe_beautyspa",
    "facebook": "https://facebook.com/JabeBeauty",
    "type": "distributor",
    "lat": 25.7928058,
    "lng": -108.990188
  },
  {
    "id": "35",
    "name": "Soraya Naez",
    "business": "CLINICA SWANN Láser Visión y Spa",
    "address": "Boulevard. Jose María Morelos #13 esquina con Benito Quintana. Col. Constitución, Hermosillo, Sonora.",
    "city": "Hermosillo",
    "state": "Sonora",
    "phone": "6681016888",
    "whatsapp": "",
    "email": "sorayabaezb@outlook.com",
    "instagram": "https://instagram.com/spa.swann",
    "facebook": "https://facebook.com/spaswann",
    "type": "distributor",
    "lat": 29.0948207,
    "lng": -110.9692202
  },
  {
    "id": "36",
    "name": "Diana Cristina Angulo Acevez ( dc Skinbeauty)",
    "business": "FLORENCIA DC Cosmiatría y Spa",
    "address": "AVENIDA MACLOVIO HERRERA #120 LOCAL 12 COLONIA BOLIVAR CP 84048",
    "city": "Nogales",
    "state": "Sonora",
    "phone": "6311811241",
    "whatsapp": "",
    "email": "diaaniuxxx21@gmail.com",
    "instagram": "https://instagram.com/florenciadc_cosmiatria",
    "facebook": "",
    "type": "distributor",
    "lat": 31.3285057,
    "lng": -110.9450472
  },
  {
    "id": "37",
    "name": "Yeraldi Del Rosario Castillo Garcia",
    "business": "Y Clinique Cosmetología-Integral",
    "address": "PROLONGACION DE SOCIALISTA No. 113 COLONIA ATASTA VILLA HERMOSA TABASCO CP. 86100 ( CASA AMARILLA CON BLANCO Y LETRERO MUJER BONITA FANNY CONTRERAS)",
    "city": "Villahermosa",
    "state": "Tabasco",
    "phone": "9931176359",
    "whatsapp": "9931176359",
    "email": "admon.yclinique@gmail.com",
    "instagram": "https://instagram.com/y.clinique",
    "facebook": "https://www.facebook.com/Y.CLINIQUE",
    "type": "distributor",
    "lat": 17.9884657,
    "lng": -92.9366326
  },
  {
    "id": "38",
    "name": "",
    "business": "DERMA ESPA COATZA",
    "address": "MALECON No. 117A FRACCIONAMIENTO BAHIA DE SAN MARTIN COATZACOALCOS VERACRUZ C.P.96536",
    "city": "Coatzacoalcos",
    "state": "Veracruz",
    "phone": "9212830644",
    "whatsapp": "9212830644",
    "email": "dermaspa.center@gmail.com",
    "instagram": "https://instagram.com/dermaspa_coatza",
    "facebook": "https://facebook.com/dermaspacentroconsmetologico",
    "type": "distributor",
    "lat": 18.1405019,
    "lng": -94.4344003
  },
  {
    "id": "39",
    "name": "Wendy Cervantes",
    "business": "PARADISE SPA",
    "address": "PINZON #662 FRACC. REFORMA",
    "city": "Veracruz",
    "state": "Veracruz",
    "phone": "2293110907",
    "whatsapp": "2293110907",
    "email": "wenlili28guz@gmail.com",
    "instagram": "https://instagram.com/_paradisespaver_",
    "facebook": "",
    "type": "distributor",
    "lat": 19.2003429,
    "lng": -96.1383572
  },
  {
    "id": "40",
    "name": "",
    "business": "Maria Bonita Spa",
    "address": "Josefa Ortiz de Dominguez #17, Col. Centro, CP 99900",
    "city": "Nochistlán de Mejía",
    "state": "Zacatecas",
    "phone": "3461047511",
    "whatsapp": "3461047511",
    "email": "spamariab@icloud.com",
    "instagram": "https://instagram.com/mariaa_bonita_spa",
    "facebook": "",
    "type": "distributor",
    "lat": 21.436113,
    "lng": -102.8272662
  }
];

// Centro inicial del mapa (CDMX, capital del país)
export const mapCenter = {
  lat: 19.4326,
  lng: -99.1332,
};

// Zoom inicial (vista nacional para ver todos los puntos al abrir)
export const defaultZoom = 5;
